const selectSidePanel = (state) => state.sidePanel

export const selectSidePanelActiveId = (state) => selectSidePanel(state).activeId
